/* eslint-disable jsx-a11y/anchor-is-valid */
/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable no-unused-vars */
import { useState, useEffect } from 'react';
import { observer } from 'mobx-react';
import { useStore } from '../../../../store/store';
import Finances from '../../../widgets/Finances';
import Carousel from '../../../shared/Carousel';
import posterImg from '../../../../_metronic/assets/media/bonus.png';
import { Button } from '../../../shared/Buttons';
import Card from '../../../shared/Card';
import PageWrapper from '../../../modules/PageWrapper';
import { Link } from 'react-router-dom';
import Employees from '../../sales/team/RD/Employees';
import { findKPILtc } from '../../../functions/findKPI';
import {findKPIRd} from '../../../functions/findKPI';
import { formatNumberToCash, formatNumber, formatNumber2 } from '../../../functions/formatNumber';
import Activity from './Activity';

const addThousands = (s) => s.replace(/\B(?=(\d{3})+(?!\d))/g, ',');

const normalizeNumericString = (value) => {
  if (value === null || value === undefined) return '0';
  let s = String(value).trim();

  // убираем валюту/пробелы, оставляем цифры, -, . , 
  s = s.replace(/\s+/g, '').replace(/[^0-9.,-]/g, '');

  // если есть и ',' и '.', считаем что ',' это тысячи -> убираем ','
  if (s.includes(',') && s.includes('.')) {
    s = s.replace(/,/g, '');
  } else {
    // если только ',', считаем что это десятичный разделитель
    s = s.replace(',', '.');
  }

  // если пусто или просто '-', вернем 0
  if (s === '' || s === '-') return '0';

  return s;
};

export const formatMoneyTruncate = (value) => {
  let s = normalizeNumericString(value);

  const isNeg = s.startsWith('-');
  if (isNeg) s = s.slice(1);

  let [intPart, fracPart = ''] = s.split('.');
  intPart = intPart.replace(/^0+(?=\d)/, ''); // убираем ведущие нули (кроме "0")

  fracPart = fracPart.slice(0, 2).padEnd(2, '0');

  const formattedInt = addThousands(intPart === '' ? '0' : intPart);
  return `${isNeg ? '-' : ''}${formattedInt}.${fracPart}$`;
};

export const formatMoneyNoDecimals = (value) => {
  let s = normalizeNumericString(value);

  const isNeg = s.startsWith('-');
  if (isNeg) s = s.slice(1);

  let intPart = s.split('.')[0];
  intPart = intPart.replace(/^0+(?=\d)/, '');

  const formattedInt = addThousands(intPart === '' ? '0' : intPart);
  return `${isNeg ? '-' : ''}${formattedInt}$`;
};


const DashboardPage = observer(({ timeConfig, isVerify, setPreloader }) => {
  const store = useStore();

  const [salesStats, setMainStats] = useState({});
  const [ltcStats, setLtcStats] = useState();
  const [managersStats, setManagerStats] = useState([]);
  const [usersCount, setUsersCount] = useState('');

  useEffect(() => {
    console.log(timeConfig);
    isVerify && timeConfig.time_config && getData();
  }, [isVerify, timeConfig]);

  const getData = async () => {
    const getSalesStats = await store.requestGet(
      `user/sales/rd/team/statistics`,
      {
        params: timeConfig,
      },
      true
    );
    const getLtcStats = await store.requestGet(`Dashboard/Sales/Ltc/Teams/getLtcStats`, {
      params: timeConfig,
    });
    const getManagersStats = await store.requestGet(`Dashboard/Sales/Rd/Teams/getManagersStats`, {
      params: timeConfig,
    });
    const LTCList = await store.requestGet(`Sales/getKpiLtcList`);

    const managersStats = getManagersStats.managers.map((item) => {
      return { ...item, indicator: findKPILtc(LTCList, item?.count_appeal, item?.ltc) };
    });

    const ltcList = await store.requestGet('Finance/Category/getLtcList');

    const ltc = ltcList.find(
      (el) => +getLtcStats.ltc >= +el.ltc_min && +getLtcStats.ltc <= +el.ltc_max
    );

    setLtcStats({ ...getLtcStats, indicator: ltc });
    setMainStats(getSalesStats);
    setManagerStats(managersStats);
    setUsersCount(getManagersStats.users_count);
    setPreloader(false);
  };

  return (
    <>
      <div className='row g-5 g-xl-10 mt-0'>
        <div className='col-xl-4 mt-0'>
          <Finances
            background={'bg_rd_manager'}
            title='Статистика'
            subTitle='Управляйте периодом в календаре.'
            stats={[
              {
                title: 'Квалификации',
                number: formatNumber(salesStats?.qualifications_count) || 0,
                icon: (
                  <i className='ki-duotone ki-fingerprint-scanning fs-1 text-primary'>
                    <span className='path1'></span>
                    <span className='path2'></span>
                    <span className='path3'></span>
                    <span className='path4'></span>
                    <span className='path5'></span>
                  </i>
                ),
              },
              {
                title: 'Депозиты',
                number: formatNumber(salesStats?.deposits_count) || 0,
                icon: (
                  <i className='ki-duotone ki-wallet fs-1 text-primary'>
                    <span className='path1'></span>
                    <span className='path2'></span>
                    <span className='path3'></span>
                    <span className='path4'></span>
                  </i>
                ),
              },
              {
                title: 'Сумма депозитов',
                number: formatMoneyNoDecimals(salesStats?.deposits_amount),
                icon: (
                  <i className='ki-duotone ki-dollar fs-1 text-primary'>
                    <span className='path1'></span>
                    <span className='path2'></span>
                    <span className='path3'></span>
                  </i>
                ),
              },
              {
                title: 'Средний чек',
               number: formatMoneyTruncate(salesStats?.players_avg_amount),
                icon: (
                  <i className='ki-duotone ki-user-tick fs-1 text-primary'>
                    <span className='path1'></span>
                    <span className='path2'></span>
                    <span className='path3'></span>
                  </i>
                ),
              },
            ]}
          />
        </div>

        <div className='col-xl-8 mb-5 mb-xl-10 mt-xl-0'>

          <style>

          </style>
          <Card className='card' data-bs-theme='light' style={{
            background: 'radial-gradient(1200px 800px at 50% 35%, #2a2f42 0%, #12131a 40%, #07070a 100%)'
          }}>
            <div className='card-body d-flex ps-xl-15'>
              <div className='m-0'>
                <div className='position-relative fs-2x z-index-2 fw-bold text-white mb-7'>
                  <span className='me-2'>
                    Приведи менеджера и получи{' '}
                    <span className='position-relative d-inline-block text-danger'>
                      <span className='text-danger opacity-75-hover'>100$</span>

                      <span className='position-absolute opacity-50 bottom-0 start-0 border-4 border-danger border-bottom w-100'></span>
                    </span>
                  </span>
                  за каждого.
                  <br /> Условия по кнопке ниже!
                </div>
                <a
                  href='https://t.me/priority0000'
                  target='_blank'
                  className='btn fw-bold  btn-danger cursor-pointer'
                  rel='noreferrer'
                >
                  Подробнее
                </a>
              </div>

              <img
                src={posterImg}
                className='position-absolute me-3 bottom-0 end-0 h-200px'
                alt=''
              />
            </div>
          </Card>
        </div>
        <div className='col-xl-12 mb-5 mb-xl-10 mt-0'>
          <Employees data={managersStats} usersCount={usersCount} />
        </div>
        {isVerify && (
          <div className='col-xl-12 mb-5 mb-xl-10 mt-0'>
            <Activity type={'ltc'} />
          </div>
        )}
      </div>
    </>
  );
});

const TeamLeadSalesRD = () => {
  return (
    <PageWrapper
      firstTimeConfig='current_week'
      mode='sales'
      breadcrumbs={[
        { title: 'Panely', path: '' },
        { isSeparator: true },
        { title: 'RD', path: '/dashboard/teamlead/rd', isActive: true },
      ]}
      title={'RD'}
    >
      <DashboardPage />
    </PageWrapper>
  );
};

export default TeamLeadSalesRD;
